import React, { useEffect, useState } from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { WixComponentTypes } from '@wix/shoutout-email-model-v3';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Text } from '../components/text';
import { Column } from '../components/column';
import { shorthand } from '../utils/css-utils';
import { getWixFooterContentByType, } from '../get-sections/get-wix-footer/wix-footer-content';
import { GenericImageContent } from './generic-image';
export const textCssClasses = {
    text: 'html-emails-text-wrapper',
};
export function SectionWixFooter(props) {
    const { section, cssClass, isRtl, columnCssClass, content } = props;
    const { outerPadding, innerPadding, textBackground, footerType } = section;
    const [textContainerProps, setTextContainerProps] = useState({
        dir: isRtl ? 'rtl' : undefined,
        style: {
            textAlign: section.align,
        },
    });
    const html = getWixFooterContentByType(footerType, content);
    useEffect(() => {
        setTextContainerProps({
            dir: isRtl ? 'rtl' : undefined,
            style: {
                textAlign: section.align,
            },
        });
    }, [isRtl, section.align]);
    const baseTextProps = {
        align: section.align,
        color: section.color,
        cssClass: textCssClasses.text,
        fontFamily: section.fontFamily,
        fontSize: section.fontSize,
        fontStyle: section.fontStyle,
        textTransform: section.textTransform,
    };
    const defaultProps = { padding: '0px' };
    const combinedTextProps = { ...{ ...defaultProps, ...baseTextProps } };
    combinedTextProps.align = undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: footerType === WixComponentTypes.classic
                    ? section.borderBottom
                    : undefined, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
                React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass, backgroundColor: textBackground.backgroundColor, border: textBackground.border, borderRadius: textBackground.borderRadius },
                    React.createElement(Text, { ...combinedTextProps },
                        React.createElement(SecureHtml, { html: html, containerProps: textContainerProps, skipCleaning: false }))))),
        footerType === WixComponentTypes.studio && (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, padding: shorthand({ top: 0, bottom: 0, left: 0, right: 0 }) },
                React.createElement(Column, null,
                    React.createElement(GenericImageContent, { src: "https://static.wixstatic.com/media/82f27b_7402268f13da423782efe210b99727ec~mv2.png/v1/fit/h_22,q_100,w_1400,al_c,lg_0/82f27b_7402268f13da423782efe210b99727ec~mv2.png", srcNonRetina: "https://static.wixstatic.com/media/82f27b_7402268f13da423782efe210b99727ec~mv2.png/v1/fit/h_11,q_100,w_700,al_c,lg_0/82f27b_7402268f13da423782efe210b99727ec~mv2.png", showAfterLoad: false, maxHeight: "11px" })))))));
}
//# sourceMappingURL=section-wix-footer.js.map